import { isCustomErrorCheck, LOCAL_USER_SESSION_EXPIRED_EVENT } from "@jti/fe-common";

const SESSION_EXPIRED_STATUS_CODE = 403;

export const handleProfileApiError = (error: unknown) => {
  if (isCustomErrorCheck(error) && error.statusCode === SESSION_EXPIRED_STATUS_CODE) {
    window.dispatchEvent(new Event(LOCAL_USER_SESSION_EXPIRED_EVENT));
  }

  return { error: error instanceof Error ? { name: error.name, message: error.message } : error };
};
